module.exports = __webpack_public_path__ + "static/media/2.0f1be092.png";